import { useTranslation } from "react-i18next";
import { GenericError } from "./GenericError.tsx";

export interface Error403ForbiddenProps {
  onClose?: () => void;
}

export const Error403Forbidden = ({ onClose }: Error403ForbiddenProps) => {
  const { t } = useTranslation("common");

  return (
    <GenericError
      errorNumber={403}
      title={t("errors.httperror403")}
      description={t("errors.httperror403detail")}
      onClose={onClose}
    />
  );
};
